import React from "react";

const BankCandidateIcon = ({ cls }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M12.561 12.0093H1.4337C1.12627 12.0093 0.877197 12.2585 0.877197 12.5663C0.877197 12.8736 1.12627 13.1227 1.4337 13.1227H12.5607C12.8682 13.1227 13.1172 12.8736 13.1172 12.5663C13.117 12.2585 12.8679 12.0093 12.561 12.0093Z"
        fill="currentColor"
      />
      <path
        d="M2.12877 10.5614C1.82134 10.5614 1.57227 10.8105 1.57227 11.1181C1.57227 11.4257 1.82134 11.6751 2.12877 11.6751H11.865C12.1725 11.6751 12.4216 11.4257 12.4216 11.1181C12.4216 10.8105 12.1725 10.5614 11.865 10.5614H11.7262V5.55182H11.865C12.019 5.55182 12.143 5.42723 12.143 5.27371C12.143 5.12019 12.0185 4.99561 11.865 4.99561H2.12877C1.97506 4.99561 1.85078 5.12019 1.85078 5.27371C1.85078 5.42723 1.97532 5.55182 2.12877 5.55182H2.2679V10.5611L2.12877 10.5614ZM10.6132 5.55182V10.5611H8.94417V5.55182H10.6132ZM7.83115 5.55182V10.5611H6.16215V5.55182H7.83115ZM3.38039 5.55182H5.04939V10.5611H3.38039V5.55182Z"
        fill="currentColor"
      />
      <path
        d="M1.43372 4.49503H12.5607C12.5626 4.49503 12.5646 4.49503 12.5662 4.49503C12.8739 4.49503 13.1227 4.24585 13.1227 3.93829C13.1227 3.69381 12.9654 3.4866 12.7468 3.41154L7.22598 0.926312C7.08086 0.861151 6.9149 0.861151 6.76952 0.926312L1.20548 3.43082C0.966051 3.53873 0.83448 3.79885 0.889714 4.05532C0.944687 4.31179 1.17135 4.49503 1.43372 4.49503Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BankCandidateIcon;
